export const EnumUserInfo = {
  USER_IP: "userIp",
  USER_INFO: "userInfo",
  USER_AGREE_COOKIES: "userAgreeCookies",
  USER_EMAIL: "USER_EMAIL",
};
